/**
 * @generated SignedSource<<29b50ec3d783dd47f96131bd304543d9>>
 * @relayHash 2889869bb927e439de517c726513b15d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46263b7b9d87568ae18db5da5a414bfa456215494e7bacb65d86ad0fd9d66698

import type { ConcreteRequest } from 'relay-runtime';
export type DeletePagesInput = {
  areChildrenIncluded?: boolean | null;
  excludedBranchRootPageIDs?: ReadonlyArray<AGG$Long | null> | null;
  isSelected?: boolean | null;
  pageID: AGG$Long;
};
export type useHandleDeleteParentPageMutation$variables = {
  input: ReadonlyArray<DeletePagesInput | null>;
};
export type useHandleDeleteParentPageMutation$data = {
  readonly deletePages: {
    readonly status: boolean;
    readonly taskId: string | null;
  } | null;
};
export type useHandleDeleteParentPageMutation = {
  response: useHandleDeleteParentPageMutation$data;
  variables: useHandleDeleteParentPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePagesPayload",
    "kind": "LinkedField",
    "name": "deletePages",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "taskId"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHandleDeleteParentPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHandleDeleteParentPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2889869bb927e439de517c726513b15d",
    "id": "46263b7b9d87568ae18db5da5a414bfa456215494e7bacb65d86ad0fd9d66698",
    "metadata": {},
    "name": "useHandleDeleteParentPageMutation",
    "operationKind": "mutation",
    "text": "mutation useHandleDeleteParentPageMutation($input:[DeletePagesInput]!){deletePages(input:$input){taskId,status}}"
  }
};
})();

(node as any).hash = "f331630de0b51709e0fd597ffc496eb6";

export default node;
